import script from "./taskBoxColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./taskBoxColumn.vue?vue&type=script&setup=true&lang=ts"

import "./taskBoxColumn.vue?vue&type=style&index=0&id=ed12a498&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed12a498"]])

export default __exports__